module.exports = "<wor-notifications></wor-notifications>\n<ui-view></ui-view>\n";